import { FleetVehicle } from './models/fleet.models';

/**
 * Semilla DETERMINISTA de la flota. Sin Math.random() ni Date.now(): cada
 * demo arranca idéntica. Placas, estados, conductores y coordenadas viven
 * aquí UNA sola vez → tabla, mapa, analíticas y perfil 360 quedan coherentes.
 *
 * Coordenadas base: Bogotá / Medellín / Cali (Colombia).
 */
export const FLEET_SEED: FleetVehicle[] = [
  {
    id: '1',
    brand: 'Toyota',
    vehicle_model: 'Camry',
    year: '2020',
    km: 23000,
    plate: 'HCM8263',
    typevehicle: 'car',
    city: { code: 'BOG', name: 'Bogotá' },
    state: { code: 'DC', name: 'Distrito Capital' },
    country: { code: 'CO', name: 'Colombia' },
    status: true,
    icon: 'https://hips.hearstapps.com/hmg-prod/images/2020-toyta-camry-mmp-1-1566921359.jpg?crop=0.878xw:0.737xh;0.0554xw,0.263xh&resize=2048:*',
    status_live: 'MOVING',
    addressLabel: 'Av. El Dorado, Bogotá',
    telemetry: { lat: 4.6784, lng: -74.0973, speedKmh: 54, heading: 45, fuelPct: 72, odometerKm: 23000, updatedAt: '2026-07-10T09:00:00Z' },
    driver: { id: 'd1', name: 'Carlos Ramírez', phone: '+57 300 111 2233', license: 'C1', avatar: 'https://i.pravatar.cc/80?img=12' },
    maintenance: [
      { id: 'm1', date: '2024-11-10', type: 'Cambio de aceite', km: 12000, cost: 180000, status: 'DONE', workshop: 'Servicentro Norte' },
      { id: 'm2', date: '2024-09-01', type: 'Pastillas de freno', km: 9500, cost: 320000, status: 'DONE', workshop: 'Frenos Bogotá' },
      { id: 'm3', date: '2026-08-15', type: 'Cambio de aceite', km: 25000, status: 'UPCOMING', alert: true },
    ],
    repairs: [
      {
        id: 'r1',
        date: '2024-12-05',
        title: 'Suspensión delantera',
        description: 'Cambio de amortiguadores delanteros',
        cost: 640000,
        workshop: 'TallerPro',
        severity: 'medium',
      },
      { id: 'r2', date: '2024-06-20', title: 'Alternador', description: 'Reemplazo de alternador', cost: 480000, workshop: 'ElectroAuto', severity: 'high' },
    ],
    expenses: [
      { id: 'e1', date: '2026-06-02', category: 'fuel', concept: 'Tanqueo Shell', amount: 220000 },
      { id: 'e2', date: '2026-05-18', category: 'maintenance', concept: 'Cambio de aceite', amount: 180000 },
      { id: 'e3', date: '2026-05-01', category: 'insurance', concept: 'SOAT', amount: 750000 },
    ],
    driverHistory: [
      { driver: { id: 'd1', name: 'Carlos Ramírez' }, from: '2026-01-01', distanceKm: 8200 },
      { driver: { id: 'd7', name: 'Andrés Gómez' }, from: '2025-06-01', to: '2025-12-31', distanceKm: 11400 },
    ],
    analytics: {
      fuelEfficiencyKmpl: 12.4,
      idleTimeHours: 18,
      costPerKm: 420,
      driverScore: 85,
      driverScoreSeries: [62, 68, 65, 72, 70, 74, 76, 78, 81, 79, 83, 85],
      behavior: { braking: 88, acceleration: 82, cornering: 76, speeding: 90 },
      monthlyFuelCost: [180, 190, 210, 200, 220, 230, 205, 215, 240, 225, 235, 220],
      distanceMonthKm: 1680,
    },
  },
  {
    id: '2',
    brand: 'Nissan',
    vehicle_model: 'GT-R',
    year: '2018',
    km: 55000,
    plate: 'GTR911',
    typevehicle: 'car',
    city: { code: 'MED', name: 'Medellín' },
    state: { code: 'ANT', name: 'Antioquia' },
    country: { code: 'CO', name: 'Colombia' },
    status: true,
    icon: 'https://wieck-nissanao-production.s3.amazonaws.com/photos/0f1f7c57cbc0c093ecd008d5c8f973bd2c9c8bb5/preview-928x522.jpg',
    status_live: 'STOPPED',
    addressLabel: 'El Poblado, Medellín',
    telemetry: { lat: 6.2088, lng: -75.5679, speedKmh: 0, heading: 0, fuelPct: 40, odometerKm: 55000, updatedAt: '2026-07-10T08:40:00Z' },
    driver: { id: 'd2', name: 'María López', phone: '+57 301 222 3344', license: 'C1', avatar: 'https://i.pravatar.cc/80?img=45' },
    maintenance: [
      { id: 'm4', date: '2025-02-14', type: 'Cambio de llantas', km: 50000, cost: 2400000, status: 'DONE', workshop: 'LlantaExpress' },
      { id: 'm5', date: '2026-07-01', type: 'Revisión técnico-mecánica', km: 56000, status: 'OVERDUE', alert: true },
    ],
    repairs: [
      {
        id: 'r3',
        date: '2025-03-10',
        title: 'Embrague',
        description: 'Cambio de kit de embrague',
        cost: 3200000,
        workshop: 'PerformanceMed',
        severity: 'high',
      },
    ],
    expenses: [
      { id: 'e4', date: '2026-06-10', category: 'fuel', concept: 'Tanqueo Terpel', amount: 310000 },
      { id: 'e5', date: '2026-04-22', category: 'repair', concept: 'Embrague', amount: 3200000 },
    ],
    driverHistory: [{ driver: { id: 'd2', name: 'María López' }, from: '2025-01-01', distanceKm: 15400 }],
    analytics: {
      fuelEfficiencyKmpl: 7.8,
      idleTimeHours: 42,
      costPerKm: 910,
      driverScore: 64,
      driverScoreSeries: [70, 66, 68, 60, 62, 58, 64, 61, 66, 63, 65, 64],
      behavior: { braking: 62, acceleration: 55, cornering: 70, speeding: 48 },
      monthlyFuelCost: [280, 300, 320, 290, 310, 330, 305, 315, 340, 320, 335, 310],
      distanceMonthKm: 980,
    },
  },
  {
    id: '3',
    brand: 'Porsche',
    vehicle_model: '911',
    year: '2019',
    km: 12000,
    plate: 'POR991',
    typevehicle: 'car',
    city: { code: 'CLO', name: 'Cali' },
    state: { code: 'VAC', name: 'Valle del Cauca' },
    country: { code: 'CO', name: 'Colombia' },
    status: false,
    icon: 'https://espirituracer.com/archivos/2017/11/nuevo-porsche-911-15.webp',
    status_live: 'IDLE',
    addressLabel: 'Taller Autopista Sur, Cali',
    telemetry: { lat: 3.4372, lng: -76.5225, speedKmh: 0, heading: 90, fuelPct: 55, odometerKm: 12000, updatedAt: '2026-07-10T08:55:00Z' },
    driver: { id: 'd3', name: 'Jorge Medina', phone: '+57 302 333 4455', license: 'C1', avatar: 'https://i.pravatar.cc/80?img=33' },
    maintenance: [{ id: 'm6', date: '2024-06-12', type: 'Rotación de llantas', km: 7000, cost: 120000, status: 'DONE', workshop: 'Servicentro Sur' }],
    repairs: [
      { id: 'r4', date: '2025-01-15', title: 'Sensor O2', description: 'Reemplazo de sensor de oxígeno', cost: 540000, workshop: 'BoschCar', severity: 'low' },
    ],
    expenses: [{ id: 'e6', date: '2026-06-01', category: 'toll', concept: 'Peajes ruta Cali', amount: 85000 }],
    driverHistory: [{ driver: { id: 'd3', name: 'Jorge Medina' }, from: '2025-08-01', distanceKm: 5200 }],
    analytics: {
      fuelEfficiencyKmpl: 8.9,
      idleTimeHours: 30,
      costPerKm: 680,
      driverScore: 78,
      driverScoreSeries: [72, 74, 73, 76, 75, 77, 78, 79, 77, 80, 79, 78],
      behavior: { braking: 80, acceleration: 74, cornering: 82, speeding: 70 },
      monthlyFuelCost: [200, 210, 205, 215, 220, 210, 225, 218, 230, 222, 228, 220],
      distanceMonthKm: 620,
    },
  },
  {
    id: '4',
    brand: 'Chevrolet',
    vehicle_model: 'NPR (Camión)',
    year: '2021',
    km: 78000,
    plate: 'XYZ987',
    typevehicle: 'truck',
    city: { code: 'BOG', name: 'Bogotá' },
    state: { code: 'DC', name: 'Distrito Capital' },
    country: { code: 'CO', name: 'Colombia' },
    status: true,
    icon: 'https://www.chevrolet.com.co/content/dam/chevrolet/mercosur/colombia/espanol/index/trucks/2021-npr/01-images/colorizer/npr-blanco.png?imwidth=960',
    status_live: 'MOVING',
    addressLabel: 'Autopista Norte Km 12, Bogotá',
    telemetry: { lat: 4.7461, lng: -74.0483, speedKmh: 38, heading: 180, fuelPct: 63, odometerKm: 78000, updatedAt: '2026-07-10T09:01:00Z' },
    driver: { id: 'd4', name: 'Luis Torres', phone: '+57 303 444 5566', license: 'C2', avatar: 'https://i.pravatar.cc/80?img=52' },
    maintenance: [
      { id: 'm7', date: '2025-05-20', type: 'Cambio de aceite', km: 72000, cost: 260000, status: 'DONE', workshop: 'DieselPro' },
      { id: 'm8', date: '2026-07-25', type: 'Frenos traseros', km: 80000, status: 'UPCOMING', alert: true },
    ],
    repairs: [
      { id: 'r5', date: '2025-09-02', title: 'Caja de cambios', description: 'Reparación de caja', cost: 4100000, workshop: 'TransCamiones', severity: 'high' },
    ],
    expenses: [
      { id: 'e7', date: '2026-06-15', category: 'fuel', concept: 'ACPM Terpel', amount: 480000 },
      { id: 'e8', date: '2026-06-05', category: 'toll', concept: 'Peajes ruta carga', amount: 210000 },
    ],
    driverHistory: [{ driver: { id: 'd4', name: 'Luis Torres' }, from: '2024-11-01', distanceKm: 28000 }],
    analytics: {
      fuelEfficiencyKmpl: 6.2,
      idleTimeHours: 55,
      costPerKm: 1120,
      driverScore: 72,
      driverScoreSeries: [68, 70, 69, 71, 70, 72, 73, 71, 74, 72, 73, 72],
      behavior: { braking: 74, acceleration: 68, cornering: 66, speeding: 80 },
      monthlyFuelCost: [420, 440, 460, 450, 470, 490, 465, 480, 500, 485, 495, 480],
      distanceMonthKm: 3200,
    },
  },
  {
    id: '5',
    brand: 'Renault',
    vehicle_model: 'Kangoo',
    year: '2022',
    km: 34000,
    plate: 'KNG442',
    typevehicle: 'van',
    city: { code: 'MED', name: 'Medellín' },
    state: { code: 'ANT', name: 'Antioquia' },
    country: { code: 'CO', name: 'Colombia' },
    status: true,
    icon: 'https://www.renault.com.co/content/dam/Renault/Colombia/vehiculos/kangoo/kangoo-express/renault-kangoo-express-blanco.png',
    status_live: 'MOVING',
    addressLabel: 'Av. Las Vegas, Medellín',
    telemetry: { lat: 6.1975, lng: -75.5754, speedKmh: 29, heading: 270, fuelPct: 48, odometerKm: 34000, updatedAt: '2026-07-10T09:02:00Z' },
    driver: { id: 'd5', name: 'Ana Ríos', phone: '+57 304 555 6677', license: 'B1', avatar: 'https://i.pravatar.cc/80?img=23' },
    maintenance: [{ id: 'm9', date: '2025-10-05', type: 'Cambio de aceite', km: 30000, cost: 170000, status: 'DONE', workshop: 'Servicentro Vegas' }],
    repairs: [],
    expenses: [{ id: 'e9', date: '2026-06-08', category: 'fuel', concept: 'Tanqueo Biomax', amount: 190000 }],
    driverHistory: [{ driver: { id: 'd5', name: 'Ana Ríos' }, from: '2025-03-01', distanceKm: 18000 }],
    analytics: {
      fuelEfficiencyKmpl: 14.2,
      idleTimeHours: 12,
      costPerKm: 350,
      driverScore: 91,
      driverScoreSeries: [82, 84, 85, 86, 88, 87, 89, 90, 91, 90, 92, 91],
      behavior: { braking: 92, acceleration: 88, cornering: 90, speeding: 94 },
      monthlyFuelCost: [150, 160, 155, 165, 170, 160, 175, 168, 180, 172, 178, 170],
      distanceMonthKm: 2100,
    },
  },
  {
    id: '6',
    brand: 'Mazda',
    vehicle_model: 'BT-50',
    year: '2020',
    km: 61000,
    plate: 'BTX501',
    typevehicle: 'pickup',
    city: { code: 'CLO', name: 'Cali' },
    state: { code: 'VAC', name: 'Valle del Cauca' },
    country: { code: 'CO', name: 'Colombia' },
    status: true,
    icon: 'https://www.mazda.com.co/globalassets/vehicles/bt-50/bt-50-blanco.png',
    status_live: 'STOPPED',
    addressLabel: 'Cra 100, Cali',
    telemetry: { lat: 3.4106, lng: -76.5417, speedKmh: 0, heading: 0, fuelPct: 22, odometerKm: 61000, updatedAt: '2026-07-10T08:30:00Z' },
    driver: { id: 'd6', name: 'Pedro Salas', phone: '+57 305 666 7788', license: 'C1', avatar: 'https://i.pravatar.cc/80?img=61' },
    maintenance: [
      { id: 'm10', date: '2025-07-18', type: 'Cambio de aceite', km: 58000, cost: 200000, status: 'DONE', workshop: 'DieselSur' },
      { id: 'm11', date: '2026-07-05', type: 'Batería', km: 61500, status: 'OVERDUE', alert: true },
    ],
    repairs: [{ id: 'r6', date: '2025-11-11', title: 'Turbo', description: 'Reparación de turbo', cost: 2800000, workshop: 'TurboCali', severity: 'high' }],
    expenses: [{ id: 'e10', date: '2026-06-12', category: 'fuel', concept: 'ACPM', amount: 260000 }],
    driverHistory: [{ driver: { id: 'd6', name: 'Pedro Salas' }, from: '2024-09-01', distanceKm: 22000 }],
    analytics: {
      fuelEfficiencyKmpl: 9.5,
      idleTimeHours: 38,
      costPerKm: 760,
      driverScore: 69,
      driverScoreSeries: [66, 68, 67, 70, 69, 68, 71, 70, 69, 72, 70, 69],
      behavior: { braking: 70, acceleration: 65, cornering: 72, speeding: 68 },
      monthlyFuelCost: [230, 240, 250, 245, 255, 260, 250, 258, 265, 260, 262, 260],
      distanceMonthKm: 1450,
    },
  },
];
